import { Actions as SearchActions } from '../../actions/search';
import { debounce } from '../../utils';
import { useDispatch, useSelector } from '../../actions/types';
import { getOnChangeValue } from '../../utils';
import { getSearchAsYouTypeEnabled } from '../../utils/globals';
import { SearchStyle } from '../../Config';
const SEARCH_AS_TYPE_DELAY = 500;
// Push a new search query
const dropdownOnSubmit = ({ value, onSubmitCallback, }) => {
    if (!value.length)
        return;
    onSubmitCallback(value);
};
const debouncedOnSubmit = debounce(dropdownOnSubmit, SEARCH_AS_TYPE_DELAY);
export function useSearchWithDropdown() {
    const dispatch = useDispatch();
    const value = useSelector((state) => state.search.inputValue); // Search input
    const onSubmitCallback = (val) => dispatch(SearchActions.searchRequest({ query: val, page: 1 }));
    const onSubmit = () => dropdownOnSubmit({
        value,
        onSubmitCallback,
    });
    const onKeyUp = (e) => {
        if (e.key === 'Enter') {
            dropdownOnSubmit({
                value,
                onSubmitCallback,
            });
        }
        else if (getSearchAsYouTypeEnabled()) {
            debouncedOnSubmit({
                value,
                onSubmitCallback,
            });
        }
    };
    const onChange = (eventOrValue) => {
        const val = getOnChangeValue(eventOrValue);
        dispatch(SearchActions.searchTermChanged(val));
    };
    // Search dropdown
    const isOpen = useSelector((state) => state.search.isOpen);
    const onCloseDropdown = () => dispatch(SearchActions.searchInputBlurred());
    const onOpenDropdown = () => dispatch(SearchActions.searchInputFocussed());
    const onReset = () => dispatch(SearchActions.searchReset());
    return {
        // Search
        searchStyle: SearchStyle.dropdown,
        value,
        onChange,
        onKeyUp,
        onSubmit,
        // Dropdown
        isOpen,
        onOpenDropdown,
        onCloseDropdown,
        onReset,
    };
}
//# sourceMappingURL=useSearchWithDropdown.js.map